import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { getUserInvitations } from 'app/agriculture/queries/invitations/getUserInvitations';
import { useCurrentUser } from 'app/agriculture/hooks/users/useCurrentUser';
import { ApiEndpoint } from 'app/agriculture/queries/apiEndpoints';
import { useUser } from 'app/agriculture/queries/users/useUser';

export function useUserInvitations() {
    const user = useCurrentUser();
    const { email } = useUser({ userId: user.id });
    const { data } = useSuspenseQuery(
        queryOptions({
            queryKey: [ApiEndpoint.invitations, { email }],
            queryFn: getUserInvitations,
        }),
    );

    return data;
}
